import script from "./logModal.vue?vue&type=script&setup=true&lang=js"
export * from "./logModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__